// GENERIERT von packages/ui/scripts/tokens-css.mjs — nicht von Hand ändern.
/** Vorgerechnete Akzent-Sets, Schlüssel = Plattform-Slug (platform.companies.slug). */
export const TENANT_ACCENT_SETS = {
    "verch": {
        "brand": "#1172b8",
        "light": {
            "accent": "#1172b8",
            "accent-hover": "#03609f",
            "accent-press": "#084f82",
            "on-accent": "#ffffff",
            "accent-ink": "#1172b8",
            "accent-soft": "#e5f2fe",
            "accent-soft-strong": "#c4e2ff",
            "accent-soft-ink": "#0a6fb5",
            "accent-line": "#1172b8"
        },
        "dark": {
            "accent": "#1172b8",
            "accent-hover": "#2c84cc",
            "accent-press": "#4197e0",
            "on-accent": "#ffffff",
            "accent-ink": "#3087cf",
            "accent-soft": "#10283e",
            "accent-soft-strong": "#153a5a",
            "accent-soft-ink": "#3e93dc",
            "accent-line": "#1172b8"
        }
    },
    "umd": {
        "brand": "#2787c8",
        "light": {
            "accent": "#147bbb",
            "accent-hover": "#0669a2",
            "accent-press": "#0d5786",
            "on-accent": "#ffffff",
            "accent-ink": "#0575b4",
            "accent-soft": "#e4f2ff",
            "accent-soft-strong": "#c2e3fe",
            "accent-soft-ink": "#1872ab",
            "accent-line": "#2787c8"
        },
        "dark": {
            "accent": "#2f8dcf",
            "accent-hover": "#45a0e3",
            "accent-press": "#59b3f7",
            "on-accent": "#10203c",
            "accent-ink": "#2b8acb",
            "accent-soft": "#0e293d",
            "accent-soft-strong": "#113b59",
            "accent-soft-ink": "#3a96d8",
            "accent-line": "#2787c8"
        }
    },
    "tt": {
        "brand": "#e30011",
        "light": {
            "accent": "#e30011",
            "accent-hover": "#c01818",
            "accent-press": "#a5060c",
            "on-accent": "#ffffff",
            "accent-ink": "#e30011",
            "accent-soft": "#feebe8",
            "accent-soft-strong": "#fed2cc",
            "accent-soft-ink": "#d5191a",
            "accent-line": "#e30011"
        },
        "dark": {
            "accent": "#e30011",
            "accent-hover": "#f92f2b",
            "accent-press": "#fa6759",
            "on-accent": "#ffffff",
            "accent-ink": "#f92f2b",
            "accent-soft": "#3b1c18",
            "accent-soft-strong": "#572823",
            "accent-soft-ink": "#fd4a40",
            "accent-line": "#e30011"
        }
    },
    "feps": {
        "brand": "#3a8d9c",
        "light": {
            "accent": "#2c8190",
            "accent-hover": "#126f7e",
            "accent-press": "#025d6a",
            "on-accent": "#ffffff",
            "accent-ink": "#247b8a",
            "accent-soft": "#d6f7fe",
            "accent-soft-strong": "#b0e9f5",
            "accent-soft-ink": "#207887",
            "accent-line": "#3a8d9c"
        },
        "dark": {
            "accent": "#4193a2",
            "accent-hover": "#55a6b5",
            "accent-press": "#68b9c8",
            "on-accent": "#10203c",
            "accent-ink": "#3a8d9c",
            "accent-soft": "#012c33",
            "accent-soft-strong": "#004049",
            "accent-soft-ink": "#4799a8",
            "accent-line": "#3a8d9c"
        }
    },
    "wg": {
        "brand": "#0ea43a",
        "light": {
            "accent": "#0ea43a",
            "accent-hover": "#018f30",
            "accent-press": "#147a2c",
            "on-accent": "#10203c",
            "accent-ink": "#05812b",
            "accent-soft": "#e2f7e3",
            "accent-soft-strong": "#c5e9c7",
            "accent-soft-ink": "#187c2f",
            "accent-line": "#0ea43a"
        },
        "dark": {
            "accent": "#0ea43a",
            "accent-hover": "#32b74d",
            "accent-press": "#4bcb60",
            "on-accent": "#10203c",
            "accent-ink": "#0ea43a",
            "accent-soft": "#152d17",
            "accent-soft-strong": "#1c4121",
            "accent-soft-ink": "#0ea43a",
            "accent-line": "#0ea43a"
        }
    },
    "qplus": {
        "brand": "#f8bf00",
        "light": {
            "accent": "#b68c0e",
            "accent-hover": "#a07b05",
            "accent-press": "#896a16",
            "on-accent": "#10203c",
            "accent-ink": "#8a6b16",
            "accent-soft": "#faefd6",
            "accent-soft-strong": "#efdcb1",
            "accent-soft-ink": "#876811",
            "accent-line": "#b68c0e"
        },
        "dark": {
            "accent": "#f8bf00",
            "accent-hover": "#e0ad09",
            "accent-press": "#c99b09",
            "on-accent": "#10203c",
            "accent-ink": "#f8bf00",
            "accent-soft": "#312404",
            "accent-soft-strong": "#483500",
            "accent-soft-ink": "#f8bf00",
            "accent-line": "#f8bf00"
        }
    }
};
export const ACCENT_NAMES = ["accent", "accent-hover", "accent-press", "on-accent", "accent-ink", "accent-soft", "accent-soft-strong", "accent-soft-ink", "accent-line"];
